import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const ChangePassword = () => {
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
  const { showCenteredPopup } = useCenteredSnackbar();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const action = key => (
      <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    if (errorMessage && key === "password") {
      if (value === formData.password_confirmation) setErrorMessage();
    }
    if (errorMessage && key === "password_confirmation") {
      if (value === formData.password) setErrorMessage();
    }
  };
  const [formData, setFormData] = useState({
    password: "",
    password_confirmation: "",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (formData.password !== formData.password_confirmation) {
      setErrorMessage(
        "Passwords do not match! Please ensure both passwords are the same."
      );
      return;
    }

    setIsLoading(true);

    const requiredFields = ["password", "password_confirmation"];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      showCenteredPopup(`Please fill in all required fields: ${missingFields.join(", ")}`,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(
      //   `Please fill in all required fields: ${missingFields.join(", ")}`,
      //   {
      //     variant: "error",
      //     persist: true,
      //     action,
      //     anchorOrigin: {
      //       vertical: "top",
      //       horizontal: "right",
      //     },
      //   }
      // );
      setIsLoading(false);
      return;
    }
    var form_data = new FormData();

    form_data.append("new_password", formData.password);
    form_data.append(
      "new_password_confirmation",
      formData.password_confirmation
    );

    const { response, message } = await Helper.Post({
      url: api_Routes.profile.changePassword.changePassword,
      data: form_data,
      hasToken: true,
    });

    if (response) {
      showCenteredPopup(message,
          { variant: "success",
            persist: true });
      // enqueueSnackbar(message, {
      //   variant: "success",
      //   persist: true,
      //   action,
      //   anchorOrigin: {
      //     vertical: "top",
      //     horizontal: "right",
      //   },
      // });
      sessionStorage.removeItem("code");
      navigate(`/profile`);
      setIsLoading(false);
    } else {
      if (typeof message === "string") {
        showCenteredPopup(message,
            { variant: "error",
              persist: true });
        // enqueueSnackbar(message, {
        //   variant: "error",
        //   persist: true,
        //   action,
        //   anchorOrigin: {
        //     vertical: "top",
        //     horizontal: "right",
        //   },
        // });
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    !sessionStorage.getItem("code") &&
      enqueueSnackbar("please verify your code first", { variant: "error",
        persist: true,
        action, });
    !sessionStorage.getItem("code") &&
      navigate("/profile/change-password/verify");
  }, []);

  return (
    <Styles>
      <Box
        sx={{
          marginBlock: "30px",
          background: "#E5EDFF",
          borderRadius: "20px",
          marginInline: { xs: "10px", md: "50px", lg: "100px" },
          padding: "40px",
        }}
        className="container"
      >
        <div className="main-data">
          <div className="logo">
            <svg
              width="226"
              height="74"
              viewBox="0 0 226 74"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.64797 40V35.5325H14.2021C15.5559 35.5325 16.5712 35.167 17.2481 34.436C17.9521 33.6778 18.304 32.6354 18.304 31.3087C18.304 29.9549 17.925 28.8854 17.1669 28.1003C16.4358 27.3151 15.3799 26.9225 13.999 26.9225H6.64797V22.455H13.6741C14.9467 22.455 15.9078 22.1572 16.5577 21.5615C17.2345 20.9387 17.573 20.0317 17.573 18.8404C17.573 17.6491 17.2481 16.7556 16.5983 16.1599C15.9755 15.5372 15.0414 15.2258 13.7959 15.2258H6.64797V10.7583H15.1362C17.7354 10.7583 19.8338 11.4217 21.4313 12.7484C23.0287 14.0751 23.8275 15.8756 23.8275 18.15C23.8275 19.585 23.489 20.8169 22.8121 21.8458C22.1352 22.8747 21.2282 23.6598 20.091 24.2014C18.9539 24.7429 17.6813 25.0136 16.2734 25.0136L16.4764 24.1607C17.9927 24.1607 19.36 24.4857 20.5784 25.1355C21.8239 25.7853 22.8121 26.7059 23.5432 27.8972C24.2742 29.0614 24.6397 30.4423 24.6397 32.0398C24.6397 33.6372 24.2607 35.0452 23.5026 36.2636C22.7715 37.4549 21.7291 38.3755 20.3753 39.0253C19.0486 39.6751 17.4782 40 15.6642 40H6.64797ZM1.53067 40V10.7583H7.78515V40H1.53067ZM38.1402 40.4061C35.8659 40.4061 33.8623 39.9594 32.1294 39.0659C30.4237 38.1453 29.0834 36.8728 28.1087 35.2482C27.161 33.5966 26.6872 31.7013 26.6872 29.5623C26.6872 27.4234 27.161 25.5551 28.1087 23.9577C29.0834 22.3602 30.4237 21.1147 32.1294 20.2212C33.8623 19.3277 35.8659 18.881 38.1402 18.881C40.4417 18.881 42.4452 19.3277 44.151 20.2212C45.8839 21.1147 47.2241 22.3602 48.1717 23.9577C49.1194 25.5551 49.5932 27.4234 49.5932 29.5623C49.5932 31.7013 49.1059 33.5966 48.1311 35.2482C47.1835 36.8728 45.8432 38.1453 44.1104 39.0659C42.4046 39.9594 40.4146 40.4061 38.1402 40.4061ZM38.1402 35.6137C39.0879 35.6137 39.9408 35.3701 40.6989 34.8827C41.4841 34.3953 42.1068 33.7049 42.5671 32.8114C43.0274 31.8908 43.2575 30.7943 43.2575 29.5217C43.2575 27.6535 42.7566 26.2185 41.7548 25.2167C40.7801 24.1878 39.5752 23.6734 38.1402 23.6734C36.7052 23.6734 35.4868 24.1878 34.485 25.2167C33.5103 26.2456 33.0229 27.6806 33.0229 29.5217C33.0229 30.7943 33.2531 31.8908 33.7134 32.8114C34.1736 33.7049 34.7828 34.3953 35.541 34.8827C36.3262 35.3701 37.1926 35.6137 38.1402 35.6137ZM62.6511 40.4061C60.3767 40.4061 58.3731 39.9594 56.6403 39.0659C54.9345 38.1453 53.5943 36.8728 52.6196 35.2482C51.6719 33.5966 51.1981 31.7013 51.1981 29.5623C51.1981 27.4234 51.6719 25.5551 52.6196 23.9577C53.5943 22.3602 54.9345 21.1147 56.6403 20.2212C58.3731 19.3277 60.3767 18.881 62.6511 18.881C64.9525 18.881 66.9561 19.3277 68.6619 20.2212C70.3947 21.1147 71.735 22.3602 72.6826 23.9577C73.6303 25.5551 74.1041 27.4234 74.1041 29.5623C74.1041 31.7013 73.6167 33.5966 72.642 35.2482C71.6943 36.8728 70.3541 38.1453 68.6213 39.0659C66.9155 39.9594 64.9254 40.4061 62.6511 40.4061ZM62.6511 35.6137C63.5987 35.6137 64.4516 35.3701 65.2097 34.8827C65.9949 34.3953 66.6177 33.7049 67.0779 32.8114C67.5382 31.8908 67.7684 30.7943 67.7684 29.5217C67.7684 27.6535 67.2675 26.2185 66.2657 25.2167C65.291 24.1878 64.0861 23.6734 62.6511 23.6734C61.2161 23.6734 59.9977 24.1878 58.9959 25.2167C58.0211 26.2456 57.5338 27.6806 57.5338 29.5217C57.5338 30.7943 57.7639 31.8908 58.2242 32.8114C58.6845 33.7049 59.2937 34.3953 60.0518 34.8827C60.837 35.3701 61.7034 35.6137 62.6511 35.6137ZM77.3335 40V10.7583H83.4255V40H77.3335ZM90.6141 40L82.004 29.2374L90.411 19.2871H97.4371L87.5681 30.1715L87.8524 28.2627L97.8433 40H90.6141Z"
                fill="#3F78E0"
              />
              <mask
                id="path-2-outside-1_1137_4374"
                maskUnits="userSpaceOnUse"
                x="103.193"
                y="8"
                width="100"
                height="35"
                fill="black"
              >
                <rect fill="white" x="103.193" y="8" width="100" height="35" />
                <path d="M118.246 40.3655C114.455 40.3655 111.423 39.5262 109.148 37.8475C106.874 36.1417 105.547 33.7455 105.168 30.6589H111.179C111.368 32.2293 112.127 33.4748 113.453 34.3953C114.78 35.2888 116.472 35.7356 118.53 35.7356C120.209 35.7356 121.495 35.4378 122.388 34.8421C123.309 34.2464 123.769 33.4477 123.769 32.4459C123.769 31.4982 123.498 30.7401 122.957 30.1715C122.415 29.5759 121.481 29.1021 120.154 28.7501L114.712 27.2474C111.923 26.4622 109.879 25.3927 108.58 24.0389C107.307 22.658 106.671 20.9387 106.671 18.881C106.671 17.1211 107.118 15.6048 108.011 14.3323C108.932 13.0327 110.218 12.0444 111.869 11.3675C113.521 10.6635 115.457 10.3116 117.677 10.3116C121.089 10.3116 123.81 11.1238 125.84 12.7484C127.871 14.3458 129.022 16.4713 129.292 19.1247H123.282C123.011 17.6897 122.348 16.6337 121.292 15.9568C120.263 15.2799 118.936 14.9415 117.312 14.9415C115.904 14.9415 114.78 15.2122 113.941 15.7538C113.101 16.2953 112.682 17.0263 112.682 17.9469C112.682 18.6509 112.912 19.3007 113.372 19.8963C113.832 20.4649 114.793 20.9523 116.256 21.3584L121.698 22.8611C124.568 23.6463 126.626 24.7293 127.871 26.1102C129.144 27.464 129.78 29.1833 129.78 31.2681C129.78 34.1923 128.765 36.4396 126.734 38.0099C124.703 39.5803 121.874 40.3655 118.246 40.3655ZM132.718 40V10.7583H142.465L150.588 38.944H147.055L155.177 10.7583H164.965V40H158.792V12.5047H159.848L151.928 40H145.471L137.632 12.7484H138.648V40H132.718ZM169.008 40V10.7583H178.756L186.878 38.944H183.345L191.468 10.7583H201.255V40H195.082V12.5047H196.138L188.218 40H181.761L173.923 12.7484H174.938V40H169.008Z" />
              </mask>
              <path
                d="M118.246 40.3655C114.455 40.3655 111.423 39.5262 109.148 37.8475C106.874 36.1417 105.547 33.7455 105.168 30.6589H111.179C111.368 32.2293 112.127 33.4748 113.453 34.3953C114.78 35.2888 116.472 35.7356 118.53 35.7356C120.209 35.7356 121.495 35.4378 122.388 34.8421C123.309 34.2464 123.769 33.4477 123.769 32.4459C123.769 31.4982 123.498 30.7401 122.957 30.1715C122.415 29.5759 121.481 29.1021 120.154 28.7501L114.712 27.2474C111.923 26.4622 109.879 25.3927 108.58 24.0389C107.307 22.658 106.671 20.9387 106.671 18.881C106.671 17.1211 107.118 15.6048 108.011 14.3323C108.932 13.0327 110.218 12.0444 111.869 11.3675C113.521 10.6635 115.457 10.3116 117.677 10.3116C121.089 10.3116 123.81 11.1238 125.84 12.7484C127.871 14.3458 129.022 16.4713 129.292 19.1247H123.282C123.011 17.6897 122.348 16.6337 121.292 15.9568C120.263 15.2799 118.936 14.9415 117.312 14.9415C115.904 14.9415 114.78 15.2122 113.941 15.7538C113.101 16.2953 112.682 17.0263 112.682 17.9469C112.682 18.6509 112.912 19.3007 113.372 19.8963C113.832 20.4649 114.793 20.9523 116.256 21.3584L121.698 22.8611C124.568 23.6463 126.626 24.7293 127.871 26.1102C129.144 27.464 129.78 29.1833 129.78 31.2681C129.78 34.1923 128.765 36.4396 126.734 38.0099C124.703 39.5803 121.874 40.3655 118.246 40.3655ZM132.718 40V10.7583H142.465L150.588 38.944H147.055L155.177 10.7583H164.965V40H158.792V12.5047H159.848L151.928 40H145.471L137.632 12.7484H138.648V40H132.718ZM169.008 40V10.7583H178.756L186.878 38.944H183.345L191.468 10.7583H201.255V40H195.082V12.5047H196.138L188.218 40H181.761L173.923 12.7484H174.938V40H169.008Z"
                fill="#F1F5FD"
              />
              <path
                d="M109.148 37.8475L108.133 39.2013L108.143 39.209L109.148 37.8475ZM105.168 30.6589V28.9667H103.255L103.488 30.8652L105.168 30.6589ZM111.179 30.6589L112.859 30.4561L112.679 28.9667H111.179V30.6589ZM113.453 34.3953L112.489 35.7857L112.498 35.7924L112.508 35.7989L113.453 34.3953ZM122.388 34.8421L121.469 33.4213L121.459 33.4276L121.45 33.4341L122.388 34.8421ZM122.957 30.1715L121.705 31.3099L121.718 31.3244L121.731 31.3386L122.957 30.1715ZM120.154 28.7501L119.704 30.3813L119.712 30.3835L119.721 30.3857L120.154 28.7501ZM114.712 27.2474L114.254 28.8763L114.262 28.8786L114.712 27.2474ZM108.58 24.0389L107.335 25.1857L107.347 25.1984L107.359 25.2108L108.58 24.0389ZM108.011 14.3323L106.63 13.3541L106.626 13.3599L108.011 14.3323ZM111.869 11.3675L112.511 12.9333L112.522 12.9289L112.533 12.9242L111.869 11.3675ZM125.84 12.7484L124.783 14.0698L124.794 14.0784L125.84 12.7484ZM129.292 19.1247V20.8169H131.166L130.976 18.9529L129.292 19.1247ZM123.282 19.1247L121.619 19.4384L121.879 20.8169H123.282V19.1247ZM121.292 15.9568L120.362 17.3705L120.37 17.3761L120.378 17.3815L121.292 15.9568ZM113.941 15.7538L114.858 17.1757L114.858 17.1757L113.941 15.7538ZM113.372 19.8963L112.033 20.931L112.045 20.9462L112.057 20.9611L113.372 19.8963ZM116.256 21.3584L115.803 22.9889L115.805 22.9896L116.256 21.3584ZM121.698 22.8611L121.247 24.4923L121.251 24.4934L121.698 22.8611ZM127.871 26.1102L126.614 27.2436L126.626 27.2565L126.638 27.2692L127.871 26.1102ZM126.734 38.0099L125.699 36.6713L126.734 38.0099ZM118.246 38.6733C114.695 38.6733 112.052 37.8872 110.153 36.486L108.143 39.209C110.793 41.1651 114.215 42.0578 118.246 42.0578V38.6733ZM110.164 36.4937C108.294 35.0916 107.176 33.1298 106.848 30.4526L103.488 30.8652C103.918 34.3612 105.454 37.1918 108.133 39.2013L110.164 36.4937ZM105.168 32.3511H111.179V28.9667H105.168V32.3511ZM109.499 30.8617C109.748 32.9232 110.774 34.5961 112.489 35.7857L114.418 33.005C113.479 32.3534 112.989 31.5354 112.859 30.4561L109.499 30.8617ZM112.508 35.7989C114.184 36.9278 116.231 37.4278 118.53 37.4278V34.0434C116.713 34.0434 115.376 33.6499 114.399 32.9917L112.508 35.7989ZM118.53 37.4278C120.369 37.4278 122.039 37.1084 123.327 36.2501L121.45 33.4341C120.95 33.7671 120.048 34.0434 118.53 34.0434V37.4278ZM123.307 36.2628C124.656 35.3904 125.461 34.0833 125.461 32.4459H122.077C122.077 32.8121 121.962 33.1025 121.469 33.4213L123.307 36.2628ZM125.461 32.4459C125.461 31.1591 125.083 29.9506 124.182 29.0045L121.731 31.3386C121.913 31.5297 122.077 31.8374 122.077 32.4459H125.461ZM124.209 29.0332C123.343 28.0804 122.033 27.4977 120.588 27.1144L119.721 30.3857C120.929 30.7064 121.488 31.0713 121.705 31.3099L124.209 29.0332ZM120.605 27.1189L115.163 25.6162L114.262 28.8786L119.704 30.3813L120.605 27.1189ZM115.171 25.6185C112.528 24.8743 110.807 23.9158 109.8 22.867L107.359 25.2108C108.951 26.8696 111.319 28.0501 114.254 28.8763L115.171 25.6185ZM109.824 22.8921C108.868 21.8548 108.363 20.558 108.363 18.881H104.979C104.979 21.3194 105.746 23.4613 107.335 25.1857L109.824 22.8921ZM108.363 18.881C108.363 17.4214 108.728 16.2558 109.396 15.3047L106.626 13.3599C105.507 14.9539 104.979 16.8207 104.979 18.881H108.363ZM109.392 15.3104C110.105 14.3037 111.12 13.5036 112.511 12.9333L111.228 9.80168C109.316 10.5852 107.758 11.7616 106.63 13.3542L109.392 15.3104ZM112.533 12.9242C113.931 12.3281 115.632 12.0038 117.677 12.0038V8.61933C115.281 8.61933 113.111 8.99893 111.206 9.81079L112.533 12.9242ZM117.677 12.0038C120.825 12.0038 123.135 12.7511 124.783 14.0698L126.897 11.427C124.484 9.49653 121.352 8.61933 117.677 8.61933V12.0038ZM124.794 14.0784C126.451 15.382 127.383 17.083 127.609 19.2965L130.976 18.9529C130.66 15.8596 129.291 13.3097 126.887 11.4184L124.794 14.0784ZM129.292 17.4325H123.282V20.8169H129.292V17.4325ZM124.945 18.8109C124.603 17.0002 123.718 15.5022 122.205 14.5322L120.378 17.3815C120.977 17.7653 121.419 18.3791 121.619 19.4384L124.945 18.8109ZM122.222 14.5431C120.841 13.6349 119.163 13.2493 117.312 13.2493V16.6337C118.709 16.6337 119.684 16.925 120.362 17.3705L122.222 14.5431ZM117.312 13.2493C115.706 13.2493 114.226 13.5555 113.023 14.3318L114.858 17.1757C115.333 16.869 116.101 16.6337 117.312 16.6337V13.2493ZM113.023 14.3318C111.75 15.1533 110.989 16.3956 110.989 17.9469H114.374C114.374 17.6571 114.453 17.4372 114.858 17.1757L113.023 14.3318ZM110.989 17.9469C110.989 19.0521 111.361 20.061 112.033 20.931L114.711 18.8616C114.463 18.5403 114.374 18.2496 114.374 17.9469H110.989ZM112.057 20.9611C112.875 21.9723 114.299 22.5712 115.803 22.9889L116.708 19.7279C115.288 19.3333 114.789 18.9575 114.687 18.8316L112.057 20.9611ZM115.805 22.9896L121.247 24.4923L122.148 21.2299L116.706 19.7272L115.805 22.9896ZM121.251 24.4934C123.98 25.2398 125.68 26.2072 126.614 27.2436L129.128 24.9768C127.571 23.2514 125.156 22.0528 122.144 21.2289L121.251 24.4934ZM126.638 27.2692C127.579 28.27 128.088 29.5571 128.088 31.2681H131.472C131.472 28.8095 130.708 26.6579 129.104 24.9512L126.638 27.2692ZM128.088 31.2681C128.088 33.7512 127.254 35.4688 125.699 36.6713L127.769 39.3486C130.275 37.4103 131.472 34.6333 131.472 31.2681H128.088ZM125.699 36.6713C124.065 37.9346 121.65 38.6733 118.246 38.6733V42.0578C122.097 42.0578 125.341 41.2261 127.769 39.3486L125.699 36.6713ZM132.718 40H131.026V41.6922H132.718V40ZM132.718 10.7583V9.06608H131.026V10.7583H132.718ZM142.465 10.7583L144.091 10.2897L143.739 9.06608H142.465V10.7583ZM150.588 38.944V40.6363H152.837L152.214 38.4754L150.588 38.944ZM147.055 38.944L145.428 38.4754L144.806 40.6363H147.055V38.944ZM155.177 10.7583V9.06608H153.904L153.551 10.2897L155.177 10.7583ZM164.965 10.7583H166.657V9.06608H164.965V10.7583ZM164.965 40V41.6922H166.657V40H164.965ZM158.792 40H157.1V41.6922H158.792V40ZM158.792 12.5047V10.8125H157.1V12.5047H158.792ZM159.848 12.5047L161.474 12.9731L162.096 10.8125H159.848V12.5047ZM151.928 40V41.6922H153.202L153.554 40.4684L151.928 40ZM145.471 40L143.844 40.4678L144.197 41.6922H145.471V40ZM137.632 12.7484V11.0561H135.385L136.006 13.2161L137.632 12.7484ZM138.648 12.7484H140.34V11.0561H138.648V12.7484ZM138.648 40V41.6922H140.34V40H138.648ZM134.41 40V10.7583H131.026V40H134.41ZM132.718 12.4505H142.465V9.06608H132.718V12.4505ZM140.839 11.2269L148.962 39.4127L152.214 38.4754L144.091 10.2897L140.839 11.2269ZM150.588 37.2518H147.055V40.6363H150.588V37.2518ZM148.681 39.4127L156.803 11.2269L153.551 10.2897L145.428 38.4754L148.681 39.4127ZM155.177 12.4505H164.965V9.06608H155.177V12.4505ZM163.273 10.7583V40H166.657V10.7583H163.273ZM164.965 38.3078H158.792V41.6922H164.965V38.3078ZM160.484 40V12.5047H157.1V40H160.484ZM158.792 14.1969H159.848V10.8125H158.792V14.1969ZM158.222 12.0363L150.302 39.5316L153.554 40.4684L161.474 12.9731L158.222 12.0363ZM151.928 38.3078H145.471V41.6922H151.928V38.3078ZM147.097 39.5322L139.258 12.2806L136.006 13.2161L143.844 40.4678L147.097 39.5322ZM137.632 14.4406H138.648V11.0561H137.632V14.4406ZM136.955 12.7484V40H140.34V12.7484H136.955ZM138.648 38.3078H132.718V41.6922H138.648V38.3078ZM169.008 40H167.316V41.6922H169.008V40ZM169.008 10.7583V9.06608H167.316V10.7583H169.008ZM178.756 10.7583L180.382 10.2897L180.029 9.06608H178.756V10.7583ZM186.878 38.944V40.6363H189.127L188.504 38.4754L186.878 38.944ZM183.345 38.944L181.719 38.4754L181.096 40.6363H183.345V38.944ZM191.468 10.7583V9.06608H190.194L189.842 10.2897L191.468 10.7583ZM201.255 10.7583H202.948V9.06608H201.255V10.7583ZM201.255 40V41.6922H202.948V40H201.255ZM195.082 40H193.39V41.6922H195.082V40ZM195.082 12.5047V10.8125H193.39V12.5047H195.082ZM196.138 12.5047L197.764 12.9731L198.387 10.8125H196.138V12.5047ZM188.218 40V41.6922H189.492L189.845 40.4684L188.218 40ZM181.761 40L180.135 40.4678L180.487 41.6922H181.761V40ZM173.923 12.7484V11.0561H171.675L172.296 13.2161L173.923 12.7484ZM174.938 12.7484H176.63V11.0561H174.938V12.7484ZM174.938 40V41.6922H176.63V40H174.938ZM170.701 40V10.7583H167.316V40H170.701ZM169.008 12.4505H178.756V9.06608H169.008V12.4505ZM177.13 11.2269L185.252 39.4127L188.504 38.4754L180.382 10.2897L177.13 11.2269ZM186.878 37.2518H183.345V40.6363H186.878V37.2518ZM184.971 39.4127L193.094 11.2269L189.842 10.2897L181.719 38.4754L184.971 39.4127ZM191.468 12.4505H201.255V9.06608H191.468V12.4505ZM199.563 10.7583V40H202.948V10.7583H199.563ZM201.255 38.3078H195.082V41.6922H201.255V38.3078ZM196.774 40V12.5047H193.39V40H196.774ZM195.082 14.1969H196.138V10.8125H195.082V14.1969ZM194.512 12.0363L186.592 39.5316L189.845 40.4684L197.764 12.9731L194.512 12.0363ZM188.218 38.3078H181.761V41.6922H188.218V38.3078ZM183.387 39.5322L175.549 12.2806L172.296 13.2161L180.135 40.4678L183.387 39.5322ZM173.923 14.4406H174.938V11.0561H173.923V14.4406ZM173.246 12.7484V40H176.63V12.7484H173.246ZM174.938 38.3078H169.008V41.6922H174.938V38.3078Z"
                fill="#3F78E0"
                mask="url(#path-2-outside-1_1137_4374)"
              />
            </svg>
          </div>
          <div className="title">Create new password</div>
          <div className="description">
            Create new password with a mix of letters, numbers <br /> and
            symbols
          </div>
        </div>
        <div className="form-data">
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Box sx={{}}>
              <TextField
                label="New Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                onChange={(e) => handleChange("password", e.target.value)}
                InputLabelProps={{
                  style: {
                    color: "#959595",
                    fontWeight: "500",
                  },
                }}
                sx={{
                  boxShadow: "-2px 2px 4px #00000040",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  marginTop: "10px",
                  "& .MuiInputBase-root": {
                    color: "black !important",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderWidth: "10px",
                    "&:hover fieldset": {
                      borderColor: "#3F78E0 !important",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3F78E0 !important",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{}}>
              <TextField
                label="confirm New Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                onChange={(e) =>
                  handleChange("password_confirmation", e.target.value)
                }
                InputLabelProps={{
                  style: {
                    color: "#959595",
                    lineHeight: "27px",
                    fontWeight: "500",
                  },
                }}
                sx={{
                  boxShadow: "-2px 2px 4px #00000040",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  marginTop: "10px",
                  "& .MuiInputBase-root": {
                    color: "black !important",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderWidth: "10px",
                    "&:hover fieldset": {
                      borderColor: "#3F78E0 !important",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3F78E0 !important",
                    },
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleTogglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            {errorMessage && (
              <Typography sx={{ color: "red", fontSize: "14px" }}>
                * {errorMessage}
              </Typography>
            )}

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  whiteSpace: "nowrap",
                  background: "#ECA601",
                  padding: "10px 30px",
                  borderRadius: "10px",
                  // Adding inner shadow using a pseudo-element
                  color: "#F1F5FD",
                  position: "relative",
                  lineHeight: "22px",
                  overflow: "hidden",
                  fontWeight: "500",
                  fontSize: "18px",
                  boxShadow: "0px 3px 3px #00000040", // Outer shadow
                  textTransform: "capitalize",
                  "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: "0 20px 20px 0",
                    background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                    filter: "blur(4px)",
                    zIndex: 1,
                  },
                  "&:hover:before": {
                    background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                  },
                }}
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" /> // Show loader when loading
                ) : (
                  "Confirm"
                )}
              </Button>
            </Box>
          </Box>
        </div>
      </Box>
    </Styles>
  );
};

export default ChangePassword;
